<template>
    <div>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: center;">
                    <v-card class="elevation-1 pa-3">
                        <v-card-title>
                            <div class="headline dialog-header">
                                {{matrixTitle}}
                            </div>
                        </v-card-title>
                        <v-card-text style="text-align: center">
                            <div style="background-color: #ededed;
                            border-bottom: 1px solid gray;
                            line-height: 60px;
                            margin-top: -33px;
                            font-size: 25px;">
                                <label :style="getStyleOfStep(0)">1. TẠO MA TRẬN</label>
                                <v-icon style="font-size: 30px;margin-left:20px;margin-right:20px">
                                    keyboard_arrow_right
                                </v-icon>
                                <label :style="getStyleOfStep(1)">2. XEM MA TRẬN</label>
                                <v-icon style="font-size: 30px;margin-left: 20px;margin-right:20px">
                                    keyboard_arrow_right
                                </v-icon>
                                <label :style="getStyleOfStep(2)">3. TẠO ĐỀ THI</label>
                            </div>
                            <div v-if="step==0 || step ==1">
                                <v-layout>
                                    <v-flex>
                                        <v-form @keyup.enter.native="onSave">
                                            <v-text-field v-validate="'required'"
                                                          label="Tên ma trận đề"
                                                          maxlength="50"
                                                          v-model="matrix.matrix_name"
                                                          name="name"
                                                          data-vv-as="Tên ma trận đề"
                                                          :error-messages="errors.first('name')"
                                                          :readonly="step!=0"
                                            />
                                        </v-form>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <table class="lstTable">
                                            <tr>
                                                <th rowspan="2" width="10%">STT</th>
                                                <th rowspan="2" width="25%">Tên bài</th>
                                                <!--th rowspan="2" width="15%">Hình thức câu hỏi</th-->
                                                <th colspan="4" width="40%">Mức độ</th>
                                                <th rowspan="2" width="10%" v-if="step==0">Xóa</th>
                                            </tr>
                                            <tr>
                                                <th width="10%">Nhận biết</th>
                                                <th width="10%">Thông hiểu</th>
                                                <th width="10%">Vận dụng</th>
                                                <th width="10%">Vận dụng cao</th>
                                            </tr>
                                            <tr v-for="(item,index) in lstThematic">
                                                <td>{{index+1}}</td>
                                                <td align="left">{{item.lesson_name}}</td>
                                                <!--td align="left">{{getQuestionType(item.question_type)}}</td-->
                                                <td align="right">{{item.lv1}}</td>
                                                <td align="right">{{item.lv2}}</td>
                                                <td align="right">{{item.lv3}}</td>
                                                <td align="right">{{item.lv4}}</td>
                                                <td v-if="step==0">
                                                    <v-btn icon flat small @click="deleteThematic(item)" v-if="step==0">
                                                        <v-icon color="pink">delete</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                            <tr v-if="lstThematic.length==0">
                                                <td colspan="7">Không có item nào</td>
                                            </tr>
                                            <tr style="font-weight: bold">
                                                <td colspan="2">Tổng: {{sumQuestion}}</td>
                                                <td>{{sumLevel0}}</td>
                                                <td>{{sumLevel1}}</td>
                                                <td>{{sumLevel2}}</td>
                                                <td>{{sumLevel3}}</td>
                                                <td v-if="step==0"></td>
                                            </tr>
                                        </table>
                                        <div style="text-align: right">
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div v-show="step==2">
                                <v-tabs v-model="examTab">
                                    <v-tab v-for="item in lstExam.length" :key="item-1" @click="tabSelectExam(item-1)">
                                        Đề {{item}}
                                    </v-tab>
                                    <!--v-tab @click="onCreateExam" :key="lstExam.length">
                                        <v-icon>note_add</v-icon>
                                    </v-tab-->
                                </v-tabs>
                                <yolearn-question :class-id="classId" :exam-id="examId" :exam="exam" type="matrix"
                                                  id="viewYoclassQuestionFromMatrix" ref="yolearn"
                                                  @cancel="step=1" @create="onSaveExam" @delete="onDeleteExam"
                                                  @change="onCreateExam" @save="onSelect"
                                />
                            </div>
                        </v-card-text>
                        <v-card-actions v-if="step==0|| step==1">
                            <v-spacer></v-spacer>
                            <v-btn class="red" dark @click="onDelete" v-if="matrixId != null && !isCopy && step==1">
                                {{$t('lang.common.delete')}}
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="addDialog=true" v-if="step==0">
                                Thêm nội dung ma trận
                            </v-btn>
                            <v-btn color="secondary" dark @click="onCopy" v-if="matrixId != null && !isCopy && step==1">
                                Sao chép ma trận
                            </v-btn>
                            <v-btn class="primary" dark @click="onSave" v-if="step==0">
                                Lưu ma trận
                            </v-btn>
                            <v-btn class="primary" dark @click="onCreateExam" v-if="step==1">
                                Tạo đề
                            </v-btn>
                            <v-btn color="cancel" @click="cancel">
                                Trở lại danh sách ma trận
                            </v-btn>
                            <!--v-btn class="info" dark @click="onCreateExam">
                                Tạo đề
                            </v-btn-->
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-dialog width="1200px" v-model="addDialog">
                    <v-card>
                        <v-card-title>
                            <div class="headline dialog-header">
                                Tìm kiếm bài học
                            </div>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex>
                                        <v-select v-validate="'required'"
                                                  :label="$t('lang.class.grade')" type="text"
                                                  v-model="clazz.gradeId"
                                                  name="grade"
                                                  :data-vv-as="$t('lang.class.grade')"
                                                  :items="grades"
                                                  readonly
                                                  item-text="grade_name"
                                                  item-value="grade_id"
                                                  @change="reloadClassBlock"
                                                  :error-messages="errors.first('grade')"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex>
                                        <v-select v-validate="'required'"
                                                  :label="$t('lang.class.classBlock')" type="text"
                                                  v-model="clazz.classBlockId"
                                                  name="classBlock"
                                                  :data-vv-as="$t('lang.class.classBlock')"
                                                  :items="classBlocks"
                                                  item-text="name"
                                                  item-value="class_block_id"
                                                  @change="reloadDescipline"
                                                  :error-messages="errors.first('classBlock')"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-select v-validate="'required'"
                                                  :label="$t('lang.class.discipline')" type="text"
                                                  v-model="clazz.disciplineId"
                                                  name="discipline"
                                                  :data-vv-as="$t('lang.class.discipline')"
                                                  :items="disciplines"
                                                  readonly
                                                  item-text="name"
                                                  item-value="subject_id"
                                                  :error-messages="errors.first('discipline')"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex>
                                        <v-select
                                                :label="$t('lang.class.chapter')" type="text"
                                                v-model="chapter"
                                                name="chapter"
                                                :data-vv-as="$t('lang.class.chapter')"
                                                :items="chapters"
                                                item-text="chapter_name"
                                                item-value="chapter_id"
                                                :error-messages="errors.first('chapter')"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex style="text-align: center">
                                        <v-btn class="yoprimary" @click="loadListChapter" dark>Lọc</v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex xm12 md12 sm12 lg12 xs12>
                                        <div>
                                            <v-form @keyup.enter.native="enterInList">
                                                <v-data-table :items="lstChapters" :headers="chapterHeader"
                                                              class="elevation-1 gru-table fixed-header lstTable">
                                                    <template slot="headers">
                                                        <tr>
                                                            <th rowspan="2" width="5%" style="color:white;font-size: 14px;font-weight: bold">STT</th>
                                                            <th rowspan="2" width="20%" style="color:white;font-size: 14px;font-weight: bold" >Tên bài</th>
                                                            <!--th rowspan="2" width="10%">Hình thức câu hỏi</th-->
                                                            <!--th rowspan="2" width="10%">Số câu đã có</th-->
                                                            <th colspan="4" width="40%" style="color:white;font-size: 14px;font-weight: bold">Mức độ</th>
                                                            <th rowspan="2" width="5%" style="color:white;font-size: 14px;font-weight: bold">Chọn</th>
                                                        </tr>
                                                        <tr style="color: white !important;">
                                                            <th width="10%" style="color:white;font-size: 14px;font-weight: bold">Nhận biết</th>
                                                            <th width="10%" style="color:white;font-size: 14px;font-weight: bold">Thông hiểu</th>
                                                            <th width="10%" style="color:white;font-size: 14px;font-weight: bold">Vận dụng</th>
                                                            <th width="10%" style="color:white;font-size: 14px;font-weight: bold">Vận dụng cao</th>
                                                        </tr>
                                                    </template>
                                                    <template slot="items" slot-scope="props">
                                                        <td class="text-xs-center">{{props.index+1}}</td>
                                                        <td class="text-xs-left">
                                                            {{props.item.lesson_name}}
                                                        </td>
                                                        <!--td class="text-xs-left">
                                                            {{getQuestionType(props.item.question_type)}}
                                                        </td-->
                                                        <!--td class="text-xs-left">
                                                            {{getNumberOfQuestion(props.item)}}
                                                        </td-->
                                                        <td class="text-xs-left">
                                                            <input class="tableInput" v-model="props.item.level0"
                                                                   pattern="[0-9]+" type="number" min="0" step="1"
                                                                   style="width: 40px"
                                                                   @change="checkError(props.item,props.index)"
                                                                   @keypress="onlyNumberKey"
                                                                   :id="'level0_'+props.index" :row="props.index"/>
                                                            <div class="error--text">{{err.level0[props.index]}}</div>

                                                        </td>
                                                        <td class="text-xs-left">
                                                            <input class="tableInput" v-model="props.item.level1"
                                                                   pattern="[0-9]+" type="number" min="0" step="1"
                                                                   style="width: 40px"
                                                                   @change="checkError(props.item,props.index)"
                                                                   @keypress="onlyNumberKey"
                                                                   :id="'level1_'+props.index" :row="props.index"/>
                                                            <div class="error--text">{{err.level1[props.index]}}</div>

                                                        </td>
                                                        <td class="text-xs-left">
                                                            <input class="tableInput" v-model="props.item.level2"
                                                                   pattern="[0-9]+" type="number" min="0" step="1"
                                                                   style="width: 40px"
                                                                   @change="checkError(props.item,props.index)"
                                                                   @keypress="onlyNumberKey"
                                                                   :id="'level2_'+props.index" :row="props.index"/>
                                                            <div class="error--text">{{err.level2[props.index]}}</div>

                                                        </td>
                                                        <td class="text-xs-left">
                                                            <input class="tableInput" v-model="props.item.level3"
                                                                   pattern="[0-9]+" type="number" min="0" step="1"
                                                                   style="width: 40px"
                                                                   @change="checkError(props.item,props.index)"
                                                                   @keypress="onlyNumberKey"
                                                                   :id="'level3_'+props.index" :row="props.index"
                                                            />
                                                            <div class="error--text">{{err.level3[props.index]}}</div>

                                                        </td>
                                                        <td class="justify-center">
                                                            <v-btn @click="addChapter(props.item)"
                                                                   class="mx-0" icon>
                                                                <v-icon color="pink">add</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </template>
                                                </v-data-table>
                                            </v-form>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="addDialog=false" dark>Đóng</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {message} from '../../../services';
    import IDatepicker from "../../../components/form/DatePicker";
    import axios from "axios/index"
    import IUpload from "../../../components/form/Upload";
    import FileView from "../fileView";
    import LibraryQuestion from "../libraryQuestion";
    import SendToMember from "../sendToMember";
    import YolearnQuestion from "../YolearnQuestion";

    export default {
        name: "matrix-create",
        components: {
            YolearnQuestion,
            SendToMember,
            LibraryQuestion,
            FileView,
            IUpload,
            IDatepicker,
        },

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            matrixId: {
                type: Number | String,
                default: () => {
                    return null;
                }
            }
        },
        data() {
            return {
                addDialog: false,
                examTab: 1,
                lstExam: [],
                exam: null,
                examId: null,
                matrix: {},
                lstThematic: [],
                step: 0,
                clazz: {},
                thematics: [
                    {"categoryName": "Phương trình", "categoryId": 1},
                    {"categoryName": "Đồ thị", "categoryId": 2},
                    {"categoryName": "Bất đẳng thức", "categoryId": 3},
                    {"categoryName": "Lượng giác", "categoryId": 4},
                ],
                lessons: [
                    {"categoryName": "Giải tích", "categoryId": 1},
                    {"categoryName": "Đại số", "categoryId": 2},
                    {"categoryName": "Hình học không gian", "categoryId": 3},
                    {"categoryName": "Hình học mặt phẳng", "categoryId": 4},
                    {"categoryName": "Lượng giác", "categoryId": 5},
                ],
                chapter: [
                    {"name": "Đồ thị", "chapterId": 1},
                    {"name": "Lượng giác", "chapterId": 2},
                    {"name": "Tích phân", "chapterId": 3},
                    {"name": "Vi phân", "chapterId": 4},
                ],
                chapterHeader: [
                    {
                        text: "STT",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Tên bài",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "lesson"
                    },
                    {
                        text: "Hình thức câu hỏi",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "questionType"
                    },
                    {
                        text: "Số câu đã có",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "existQuestion"
                    },
                    {
                        text: "Nhận biết",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Thông hiểu",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Vận dụng",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Vận dụng cao",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Thêm",
                        align: "left",
                        search: false,
                        sortable: false,
                        value: "name"
                    },

                ],
                lstChapters: [],
                chapters: null,
                subjects: [],
                classBlocks: [],
                disciplines: [],
                grades: [],
                repeat_question: 0,
                isCopy: false,
                err: {
                    level0: [],
                    level1: [],
                    level2: [],
                    level3: []
                },
            }
        },

        computed: {
            matrixTitle: function () {
                if (this.matrixId == null || this.matrixId == "") {
                    return "MA TRẬN ĐỀ";
                } else {
                    return "SỬA MA TRẬN ĐỀ";
                }
            },

            sumQuestion() {
                let sum = 0;
                for (let i = 0; i < this.lstThematic.length; i++) {
                    sum += parseInt(this.lstThematic[i].lv1) + parseInt(this.lstThematic[i].lv2) + parseInt(this.lstThematic[i].lv3) + parseInt(this.lstThematic[i].lv4);
                }
                return sum + " câu";
            },
            sumLevel0() {
                let sum = 0;
                let sum0 = 0;
                for (let i = 0; i < this.lstThematic.length; i++) {
                    sum0 += parseInt(this.lstThematic[i].lv1);
                    sum += parseInt(this.lstThematic[i].lv1) + parseInt(this.lstThematic[i].lv2) + parseInt(this.lstThematic[i].lv3) + parseInt(this.lstThematic[i].lv4);
                }
                let percent = 0;
                if (sum > 0) {
                    percent = (sum0 * 100 / sum).toFixed(2);
                }
                return sum0 + " câu (" + percent + "%)";
            },
            sumLevel1() {
                let sum = 0;
                let sum0 = 0;
                for (let i = 0; i < this.lstThematic.length; i++) {
                    sum0 += parseInt(this.lstThematic[i].lv2);
                    sum += parseInt(this.lstThematic[i].lv1) + parseInt(this.lstThematic[i].lv2) + parseInt(this.lstThematic[i].lv3) + parseInt(this.lstThematic[i].lv4);
                }
                let percent = 0;
                if (sum > 0) {
                    percent = (sum0 * 100 / sum).toFixed(2);
                }
                return sum0 + " câu (" + percent + "%)";

            },
            sumLevel2() {
                let sum = 0;
                let sum0 = 0;
                for (let i = 0; i < this.lstThematic.length; i++) {
                    sum0 += parseInt(this.lstThematic[i].lv3);
                    sum += parseInt(this.lstThematic[i].lv1) + parseInt(this.lstThematic[i].lv2) + parseInt(this.lstThematic[i].lv3) + parseInt(this.lstThematic[i].lv4);
                }
                let percent = 0;
                if (sum > 0) {
                    percent = (sum0 * 100 / sum).toFixed(2);
                }
                return sum0 + " câu (" + percent + "%)";

            },
            sumLevel3() {
                let sum = 0;
                let sum0 = 0;
                for (let i = 0; i < this.lstThematic.length; i++) {
                    sum0 += parseInt(this.lstThematic[i].lv4);
                    sum += parseInt(this.lstThematic[i].lv1) + parseInt(this.lstThematic[i].lv2) + parseInt(this.lstThematic[i].lv3) + parseInt(this.lstThematic[i].lv4);
                }
                let percent = 0;
                if (sum > 0) {
                    percent = (sum0 * 100 / sum).toFixed(2);
                }
                return sum0 + " câu (" + percent + "%)";

            }
        },

        watch: {
            matrixId: function (data) {
                this.getMatrix(data);
            },
            addDialog(data) {
                this.getClassInfo();
            }
        },

        created() {
            this.getClassInfo();
            if (this.matrixId == null) {
                this.matrix = {};
                this.lstThematic = [];
            } else {
                this.getMatrix();
            }
        },

        mounted: function () {
        },

        methods: {
            onlyNumberKey($event) {
                let ASCIICode = ($event.which) ? $event.which : $event.keyCode;
                console.log(ASCIICode);
                if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
                    $event.preventDefault();;
            },

            getStyleOfStep(step) {
                if (this.step == step) {
                    return "font-weight:bold;color:blue";
                } else {
                    return "";
                }
            },

            getQuestionType(questionType) {
                if (questionType == 0) {
                    return "Lý thuyết";
                } else if (questionType == 1) {
                    return "Bài tập";
                }
            },

            getNumberOfQuestion(item) {
                return "[" + item.lv1 + "][" + item.lv2 + "][" + item.lv3 + "][" + item.lv4 + "]";
            },

            reloadClasGrade: function () {
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/grade").then(
                    data => {
                        this.grades = data.data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            reloadClassBlock: function () {
                if (this.clazz.gradeId == undefined || this.clazz.gradeId == null) {
                    this.classBlocks = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/class_blocks?grade_id=" + this.clazz.gradeId).then(
                    data => {
                        this.classBlocks = data.data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            reloadDescipline: function () {
                if (this.clazz.classBlockId == undefined || this.clazz.classBlockId == null) {
                    this.disciplines = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/subjects?class_block_id=" + this.clazz.classBlockId).then(
                    data => {
                        this.disciplines = data.data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            loadChapter: function () {
                if (this.clazz == null) {
                    this.chapters = [];
                    return;
                }
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/list_chapter?class_block_id=" + this.clazz.classBlockId + "&subject_id=" + this.clazz.disciplineId).then(
                    data => {
                        this.chapters = data.data;
                        //console.log(this.chapters);
                    },
                    error => {
                        console.log(error);
                    }
                )

            },

            loadListChapter() {
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/list_lesson_matrix?token=yoclass&chapter_id=" + this.chapter).then(
                    data => {
                        this.lstChapters = data.data;
                        //console.log(this.chapters);
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            getClassInfo() {
                if (this.classId != null && this.classId != undefined) {
                    axios.post(process.env.VUE_APP_API_URL + "/class/getClass?classId=" + this.classId).then(
                        data => {
                            this.clazz = data;
                            this.reloadClassBlock();
                            this.reloadClasGrade();
                            this.reloadDescipline();
                            this.loadChapter();
                        },
                        error => {
                            console.log(error);
                        }
                    );
                }
            },

            getMatrix: function () {
                if (this.matrixId == null || this.matrixId == undefined) {
                    this.step = 0;
                    return;
                }
                this.step = 1;
                let userId = this.$store.state.auth.user.userId;
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/matrix-detail?token=yoclass&matrix_id=" + this.matrixId + "&user_id=" + userId + "&class_id=" + this.classId).then(
                    data => {
                        this.matrix = data.data[0];
                        try {
                            this.lstThematic = this.matrix.matrix_list;
                        } catch (e) {
                            this.lstThematic = null;
                        }
                        if (this.lstThematic == null) {
                            this.lstThematic = [];
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )

            },

            addThematic: function () {
                let newitem = {
                    "thematic": null,
                    "lesson": null,
                    "markPercent": 0,
                    "lstLevel": [
                        {"name": "Nhận biết", "theory": 0, "practice": 0, "": 0, "totalMark": 0},
                        {"name": "Thông hiểu", "theory": 0, "practice": 0, "": 0, "totalMark": 0},
                        {"name": "Vận dụng", "theory": 0, "practice": 0, "": 0, "totalMark": 0},
                        {"name": "Vận dụng cao", "theory": 0, "practice": 0, "": 0, "totalMark": 0},
                    ]
                }
                this.lstThematic.push(newitem);
            },

            addChapter: function (chapter) {
                let badd = true;
                if (chapter.level0 == undefined || chapter.level0 == null || chapter.level0 == "") {
                    chapter.level0 = 0;
                    /*
                                        message.error("Chưa nhập số câu hỏi nhận biết");
                                        return;
                    */
                }
                if (chapter.level0 > chapter.lv1) {
                    message.error("Số câu hỏi nhận biết lớn hơn số lượng câu hỏi trong kho");
                    return;
                }

                if (chapter.level1 == undefined || chapter.level1 == null || chapter.level1 == "") {
                    chapter.level1 = 0;
                    /*
                                        message.error("Chưa nhập số câu hỏi thông hiểu");
                                        return;
                    */
                }
                if (chapter.level1 > chapter.lv2) {
                    message.error("Số câu hỏi thông hiểu lớn hơn số lượng câu hỏi trong kho");
                    return;
                }

                if (chapter.level2 == undefined || chapter.level2 == null || chapter.level2 == "") {
                    chapter.level2 = 0;
                    /*
                                        message.error("Chưa nhập số câu hỏi vận dụng");
                                        return;
                    */
                }
                if (chapter.level2 > chapter.lv3) {
                    message.error("Số câu hỏi vận dụng lớn hơn số lượng câu hỏi trong kho");
                    return;
                }
                if (chapter.level3 == undefined || chapter.level3 == null || chapter.level3 == "") {
                    chapter.level3 = 0;
                    /*
                                        message.error("Chưa nhập số câu hỏi vận dụng nâng cao");
                                        return;
                    */
                }
                if (chapter.level3 > chapter.lv4) {
                    message.error("Số câu hỏi vận dụng nâng cao lớn hơn số lượng câu hỏi trong kho");
                    return;
                }
                let addOb = {
                    lesson_id: chapter.lesson_id,
                    lesson_name: chapter.lesson_name,
                    //question_type: chapter.question_type,
                    lv1: chapter.level0,
                    lv2: chapter.level1,
                    lv3: chapter.level2,
                    lv4: chapter.level3,
                }
                for (let i = 0; i < this.lstThematic.length; i++) {
                    if (this.lstThematic[i].lesson_id == addOb.lesson_id && this.lstThematic[i].question_type == addOb.question_type) {
                        this.lstThematic.splice(i,1,addOb);
                        //this.lstThematic[i] = addOb;
                        badd = false;
                        break;
                    }
                }
                if (badd) {
                    this.lstThematic.push(addOb);
                }
                message.success("Đã thêm thành công");
            },

            deleteThematic: function (item) {
                for (let i = 0; i < this.lstThematic.length; i++) {
                    if (this.lstThematic[i] == item) {
                        this.lstThematic.splice(i, 1);
                        break;
                    }
                }
            },

            checkError(item, index) {

            },

            onSave() {
                this.$validator.validate().then(valid => {
                    //console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    //console.log(this.class);
                    if (this.matrixId == null) {
                        this.matrix.matrix_id = null;
                        this.matrix.class_id = this.clazz.classId;
                        this.matrix.block_id = this.clazz.classBlockId;
                        this.matrix.subject_id = this.clazz.disciplineId;
                        this.matrix.user_id = this.$store.state.auth.user.userId;
                        this.matrix.user_name = this.$store.state.auth.user.username
                    } else {
                        this.matrix.class_id = this.clazz.classId;
                        this.matrix.block_id = this.clazz.classBlockId;
                        this.matrix.subject_id = this.clazz.disciplineId;
                        this.matrix.user_id = this.$store.state.auth.user.userId;
                        this.matrix.user_name = this.$store.state.auth.user.username
                    }
                    this.matrix.matrix_list = this.lstThematic;
                    axios.post(process.env.VUE_APP_YO_LEARN_API + "/save-matrix", this.matrix).then(
                        data => {
                            console.log(data);
                            if (data.status == "200") {
                                message.success(this.$t("lang.common.save_success"));
                                this.isCopy = false;
                                this.$emit("onUpdate",data.data[0].matrix_id);
                                this.matrix.matrix_id = data.data[0].matrix_id;
                                //console.log(this.matrix);
                                //this.cancel();
                                this.step = 1;
                            } else {
                                message.error(this.$t(data.message));
                            }
                        },
                        error => {
                            console.log(error);
                        }
                    );
                });
            },

            onCopy() {
                this.matrix.matrix_id = null;
                this.isCopy = true;
                this.step = 0;
            },

            onCreateExam() {
                this.step = 2;
                let userId = this.$store.state.auth.user.userId;
                axios.get(process.env.VUE_APP_YO_LEARN_API + "/create-exam?token=yoclass&matrix_id=" + this.matrixId + "&user_id=" + userId + "&class_id=" + this.classId + "&repeat_question=0").then(
                    data => {
                        this.lstExam.push(data);
                        this.examId = data.exam_id;
                        this.exam = data;
                        this.examTab = this.lstExam.length - 1;
                        /*
                                                this.$nextTick(
                                                    ()=>{
                                                        this.examTab =this.lstExam.length;
                                                    }
                                                )
                        */
                    },
                    error => {
                        message.error(error);
                    }
                )

            },

            tabSelectExam(item) {
                this.exam = this.lstExam[item];
                this.examId = this.exam.exam_id;
            },

            onSelect(examination) {
                //console.log(" matrix create onselect ");
                this.$emit("save", examination);
            },

            onSaveExam(exam) {
                let ob = {
                    "exam_key": exam.exam_key,
                    "exam_name": exam.exam_name,
                    "user_id": this.$store.state.auth.user.userId
                }
                axios.post(process.env.VUE_APP_YO_LEARN_API + "/save-exam?token=yoclass&matrix_id=" + this.matrixId, ob).then(
                    data => {
                        if (data.status == 200) {
                            //this.examId = data.exam_id;
                            //this.exam = null;
                            //exam.exam_id = data.exam_id;
                            // get exam by examId because exam was reordered after save
                            axios.get(process.env.VUE_APP_YO_LEARN_API+"/exams/exam_detail?token=yoclass&exam_id=" + data.exam_id).then(
                                examDetail => {
                                    this.examId = examDetail.exam_id;
                                    this.exam = examDetail;
                                },
                                error => {
                                    console.log(error);
                                }

                            )
                            message.success("Lưu đề thành công");
                        } else {
                            message.error(data.message);
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            onDeleteExam(exam) {
                let ob = {
                    "exam_key": exam.exam_key,
                    "exam_name": exam.exam_name,
                    "user_id": this.$store.state.auth.user.userId
                }
                let userId = this.$store.state.auth.user.userId;
                axios.delete(process.env.VUE_APP_YO_LEARN_API + "/delete-exam?token=yoclass&user_id=" + userId + "&exam_key=" + exam.exam_key).then(
                    data => {
                        if (data.status == 200) {
                            message.success("Xóa đề thành công");
                            for (let i = 0; i < this.lstExam.length; i++) {
                                if (this.lstExam[i].exam_key == exam.exam_key) {
                                    this.lstExam.splice(i, 1);
                                    //console.log(this.lstExam.length);
                                    if (this.lstExam.length > 0) {
                                        if (i < this.lstExam.length) {
                                            this.exam = this.lstExam[i];
                                            this.examId = this.exam.exam_id;
                                        } else {
                                            this.exam = this.lstExam[this.lstExam.length - 1];
                                            this.examId = this.exam.exam_id;
                                        }
                                    } else {
                                        //console.log("SDfdsfdsf");
                                        this.step = 1;
                                        this.exam = null;
                                        this.examId = null;
                                    }
                                    break;
                                }
                            }

                        } else {
                            message.error(data.message);
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            onDelete() {
                if (confirm("Bạn có chắc chắn muốn xóa ma trận không?")) {
                    let userId = this.$store.state.auth.user.userId;
                    axios.delete(process.env.VUE_APP_YO_LEARN_API + "/delete-matrix?token=yoclass&matrix_id=" + this.matrixId + "&user_id=" + userId).then(
                        data => {
                            if (data.status == 200) {
                                message.success("Xóa ma trận thành công");
                                this.cancel();
                            } else {
                                message.error(data.message);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )
                }
            },

            cancel: function () {
                if(this.step==1){
                    this.$emit("cancel");
                } else if ((this.matrix.matrix_name == null || this.matrix.matrix_name == "") && this.lstThematic.length == 0) {
                    this.$emit("cancel");
                } else {
                    if (confirm("Bạn chưa lưu ma trận, bạn có chắc quay lại không?")) {
                        this.$emit("cancel");
                    }
                }
            },
        }
    };
</script>

